var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.73 11.27C23.97 7.13 20.36 4 16 4C11.64 4 8.03 7.14 7.27 11.27C3.14 12.03 0 15.64 0 20C0 24.91 3.98 28.89 8.89 28.89H13.33V21.78H10.66L15.99 14.67L21.32 21.78H18.65V28.89H23.09C28 28.89 31.98 24.91 31.98 20C31.98 15.64 28.84 12.03 24.71 11.27H24.73Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.573ad14439d25b66cfac6f16e1aec126.svg";
export { ForwardRef as ReactComponent };